import { userReducer } from "./user.reducer";
import { employeeReducer } from "./employee.reducer";
import { spinnerReducer } from "./spinner.reducer";

//Exporting reducers for other redux
const allReducers = {
  userReducer,
  employeeReducer,
  spinnerReducer,
};

export default allReducers;
